const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the in app slack template component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('slackTemplate', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentType: '=',
      content: '='
    },
    template: require('../../../templates/directives/messaging/slack-template.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.body = '';
      self.addTemplate;

      if (!$scope.content || !$scope.content.messaging) {
        return;
      }
      if (!$scope.content.messaging.slack) {
        $scope.content.messaging.slack = [];
      }

      $scope.content.messaging.slack.forEach(function(item) {
        if (item.name === 'body') {
          self.body = item.value.slice(0);
        }
      });


      self.replacements = {
        showDropdown: false,
        options: {
          Workshop: {
            'recipient_first_name': 'Recipient First Name',
            'recipient_last_name': 'Recipient Last Name',
            'sender_first_name': 'Sender First Name',
            'sender_last_name': 'Sender Last Name',
            'workshop_title': 'Workshop Title',
            'host_name': 'Host Name'
          },
          assignment: {
            due_in: 'Due from now in Days',
            assigner_first_name: 'Assigner First Name',
            assigner_last_name: 'Assigner Last Name',
            assignee_first_name: 'Assignee First Name',
            assignee_last_name: 'Assignee Last Name',
            recipient_first_name: 'Recipient First Name',
            recipient_last_name: 'Recipient Last Name'
          }
        },
        insertVariable: function(key) {
          key = '{' + key + '}';
          var elem = document.getElementById('dm-slack-message');
          if (elem.selection) {
            // IE
            elem.focus();
            var sel = elem.selection.createRange();
            sel.text = key;
          } else if (elem.selectionStart || elem.selectionStart === 0) {
            // Others
            var startPos = elem.selectionStart;
            var endPos = elem.selectionEnd;
            elem.value = elem.value.substring(0, startPos) +
              key +
              elem.value.substring(endPos, elem.value.length);
            elem.selectionStart = startPos + key.length;
            elem.selectionEnd = startPos + key.length;
          } else {
            elem.value += key;
          }
          self.replacements.showDropdown = false;
        }
      };



      self.update = function() {
        var bodySet = false;
        var templateSet = false;

        $scope.content.messaging.slack.forEach(function(item) {
          if (item.name === 'body') {
            item.value = self.body
            bodySet = true;
          }
          if (item.name === 'include_template') {
            item.value = self.addTemplate ? 'active' : 'inactive';
            templateSet = true;
          }
        });

        if (!bodySet) {
          $scope.content.messaging.slack.push({name: 'body', value: self.body});
        }

        if (!templateSet) {
          $scope.content.messaging.slack.push({name: 'include_template', value: self.addTemplate ? 'active' : 'inactive'});
        }
      };

      self.toggleClick = function() {
        self.addTemplate = !self.addTemplate;
        self.update();
      };

      self.templateSetting = function() {
        self.addTemplate = false;
        $scope.content.messaging.slack.forEach(function(opt) {
          if (opt.name === 'include_template' && opt.value === 'active') {
            self.addTemplate = true;
          }
        });
      };

      self.templateSetting();

      $scope.$watch('content.messaging', function(newVal, oldVal) {
        self.templateSetting();
      }, true);
    }],
    controllerAs: 'slackMessage'
  }
}]);